import * as React from "react";
/**
 * @example
 *
 * ```jsx
 * import { Legend, LegendEntryComponent } from "@skve/components"
 *
 * const legendEntry1 = {
 *  name: "Störung",
 *  xValue: "3.7. 11:30 - 5.7. 15:45",
 *  yValue: "0 - 0",
 *  unit: "kW",
 *  color: "purple",
 *  extension: null
 * }
 *
 * const legendEntry2 = {
 *  name: "Wärme",
 *  xValue: "1.7. 14:30 - 2.7. 15:45",
 *  yValue: "300 - 500",
 *  unit: "kW",
 *  color: "grey",
 *  extension: null
 * }
 *
 * const legendEntryComponent1 = <LegendEntryComponent {...legendEntry1}  />;
 * const legendEntryComponent2 = <LegendEntryComponent {...legendEntry2}  />;
 *
 * const legendEntries = [legendEntryComponent1, legendEntryComponent2];
 *
 * function Demo() {
 *   return <Legend legendHeight={126} legendEntries={legendEntries}></Legend>
 * }
 * ```
 */
const Legend = ({ legendEntries }) => {
    if (!legendEntries || legendEntries.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "flex flex-col flex-wrap bg-background rounded gap-x-4 px-2 py-1 text-primary-foreground mt-1 text-xs" }, legendEntries));
};
Legend.displayName = "Legend";
export { Legend };
//# sourceMappingURL=legend.js.map